import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=0190bf41&"
import script from "./ContentView.vue?vue&type=script&lang=ts&"
export * from "./ContentView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports